module.exports = __webpack_public_path__ + "static/success-628b4c02d52329fe29ef1a04aa010c8c.png";